/* eslint-disable react/no-multi-comp */
import React from 'react';

export const CostReasonIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#F28C8D" rx="4" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M7.74 14c-.437 0-.74.386-.74.74v17a.77.77 0 0 0 .74.75.77.77 0 0 0 .738-.75V15.477h30.305a.77.77 0 0 0 .75-.739.77.77 0 0 0-.75-.739H7.739zm2.956 2.957c-.426 0-.73.406-.74.739v16.26c0 .388.353.74.74.74H40.26c.387 0 .739-.352.739-.74v-16.26a.768.768 0 0 0-.74-.74H10.697zm.739 1.478h8.373c-1.962 1.77-3.2 4.434-3.2 7.391 0 2.963 1.243 5.624 3.211 7.391h-8.384V18.435zm10.948 0h6.19c2.513 1.278 4.297 4.096 4.297 7.391 0 3.306-1.795 6.12-4.32 7.391h-6.144c-2.525-1.272-4.319-4.085-4.319-7.39 0-3.296 1.783-6.114 4.296-7.392zm8.766 0h8.373v14.782h-8.385c1.969-1.767 3.21-4.428 3.21-7.39 0-2.958-1.237-5.621-3.198-7.392zm-5.67 1.109a.74.74 0 0 0-.74.739v.462a2.928 2.928 0 0 0-2.217 2.864c0 .926.45 1.65 1.005 2.055.406.297.82.47 1.212.636v3.014a2.12 2.12 0 0 1-.82-.866c-.148-.383-.65-.576-1.016-.393-.367.183-.517.703-.3 1.051.383.767 1.124 1.54 2.136 1.802v.462a.74.74 0 1 0 1.478 0v-.462a2.928 2.928 0 0 0 2.218-2.864c0-.927-.45-1.663-1.005-2.068-.406-.296-.82-.47-1.213-.635v-3.003c.362.203.655.525.82.855.149.382.65.576 1.017.393.366-.184.517-.703.3-1.051-.383-.767-1.125-1.531-2.137-1.79v-.462a.74.74 0 0 0-.739-.74zm-.74 2.737v2.39c-.532-.236-.736-.587-.739-1.062 0-.68.276-1.117.74-1.328zm1.478 4.688c.534.236.748.619.74 1.074 0 .68-.276 1.117-.74 1.328v-2.402z"
      />
    </g>
  </svg>
);

export const PlanReasonIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#308C8F" rx="4" />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M38.245 11.925l-.147-.1a3.55 3.55 0 0 0-4.115.066l-.934.676-.933-.674a3.585 3.585 0 0 0-1.74-.664v-1.096A2.135 2.135 0 0 0 28.24 8H13.275c-1.18 0-2.137.955-2.137 2.133v1.6H9.534a.534.534 0 0 0-.534.534v12.266c0 .884.718 1.6 1.603 1.6h3.741v8.8c0 1.031.838 1.867 1.87 1.867.09-.003.18-.012.268-.027v.027h2.672v2.667c0 .294.24.533.534.533h14.964a.534.534 0 0 0 .534-.533v-6.4c0-.884-.717-1.6-1.603-1.6h-3.206V20.872l2.33 1.938a.535.535 0 0 0 .684 0l4.948-4.117a4.04 4.04 0 0 0 1.516-2.251 4.214 4.214 0 0 0-1.61-4.517zM10.07 24.533V12.8h1.069v11.733a.534.534 0 0 1-1.07 0zm2.04.534c.062-.171.096-.352.097-.534v-14.4a1.068 1.068 0 0 1 2.138 0v14.934h-2.236zm5.788 10.666c.122-.249.186-.522.188-.8v-1.866a.534.534 0 0 1 1.069 0v2.666h-1.257zm16.22-2.666v5.866H20.223v-5.866a1.579 1.579 0 0 0-.099-.534h13.46c.294 0 .533.24.533.534zm-4.81-1.6H18.62c-.885 0-1.603.716-1.603 1.6v1.866a.8.8 0 0 1-1.603 0v-24.8a2.108 2.108 0 0 0-.297-1.066h13.123c.59 0 1.069.477 1.069 1.066v1.149a3.595 3.595 0 0 0-1.31.544l-.145.1a4.215 4.215 0 0 0-1.61 4.516c.226.891.751 1.678 1.488 2.23l1.577 1.311v11.484zM38.82 16.17a3.002 3.002 0 0 1-1.138 1.681l-4.633 3.855-4.662-3.875a2.98 2.98 0 0 1-1.11-1.661 3.134 3.134 0 0 1 1.176-3.364l.146-.1a2.49 2.49 0 0 1 2.885.048l1.247.903a.535.535 0 0 0 .628 0l1.247-.903a2.488 2.488 0 0 1 2.886-.048l.147.1a3.134 3.134 0 0 1 1.181 3.364z" />
        <path d="M17 10h6v1h-6zM24 10h2v1h-2zM17 13h6v1h-6zM25 13h2v1h-2zM17 15h4v1h-4zM17 18h5v1h-5zM17 21h7v1h-7zM17 23h10v1H17zM17 26h8v1h-8zM17 29h9v1h-9zM27 26h2v1h-2zM22 34h8v1h-8zM22 36h9v1h-9zM32 34h2v1h-2zM37.5 40c.194 0 .37-.119.452-.304l1-2.26a.551.551 0 0 0 .048-.224V22.529c0-.292-.224-.529-.5-.529h-2c-.276 0-.5.237-.5.53v14.682c0 .077.016.154.048.225l1 2.259A.499.499 0 0 0 37.5 40zm.5-14.294h-1v-.53h1v.53zm0-2.647v1.059h-1v-1.06h1zm-1 3.706h1v10.33l-.5 1.128-.5-1.129v-10.33z" />
      </g>
    </g>
  </svg>
);

export const EaseReasonIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#069" rx="4" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M39.434 19.766c0 3.562-2.845 6.292-6.355 6.292-3.51 0-6.355-2.73-6.355-6.292"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M20.021 25.802c.834.345 1.594.933 2.235 1.679M7.198 35.66v-2.648a8.528 8.528 0 0 1 3.917-7.199"
      />
      <g fill="#FFF" fillRule="nonzero" transform="translate(11.69 19.55)">
        <ellipse cx="6.556" cy="1.124" rx="1" ry="1" />
        <path d="M1.99 1.124a.842.842 0 0 1-.836.849.841.841 0 0 1-.837-.849c0-.468.374-.848.837-.848.46 0 .836.38.836.848z" />
      </g>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M16.665 24.406c-.146.346-.488.693-1.09.693-.602 0-.976-.347-1.09-.693"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.562 20.575s-.418.838-.418 2.17h1.089"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M23.285 26.379v-7.655c0-4.3-3.435-7.787-7.672-7.787-4.238 0-7.672 3.486-7.672 7.787v7.655s.266 2.149-1.889 2.149"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M37.6 24.377a8.525 8.525 0 0 1 3.92 7.218l-.005 4.064M25.372 27.574c.676-1.48 1.73-2.71 3.321-3.211"
      />
      <g fill="#FFF" fillRule="nonzero" transform="translate(29.574 17.488)">
        <ellipse cx="6.249" cy="1.145" rx="1" ry="1" />
        <ellipse cx=".847" cy="1.145" rx="1" ry="1" />
      </g>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M34.446 22.625c-.178.421-.592.842-1.324.842-.732 0-1.187-.42-1.325-.842"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M33.317 18.665s-.604.973-.604 2.552h1.088M39.435 19.866s-.047-2.69 1.338-2.69"
      />
      <g
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M24.893 18.057v1.757c0 .655.523 1.186 1.168 1.186M26.585 21h-.524" />
      </g>
      <g
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M41.126 18.057v1.757c0 .655-.523 1.186-1.168 1.186M39.958 21h-.524" />
      </g>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21.866 18.403h-5.388c-3.861 0-4.47-3.117-4.47-3.117s-2.751 1.005-2.751 4.397v1.596c0 3.533 2.823 6.398 6.305 6.398 3.481 0 6.304-2.864 6.304-6.398v-2.876M40.773 17.175c.455 0 .422-.576.422-.576 0-4.558-3.64-8.253-8.13-8.253-4.491 0-8.132 3.695-8.132 8.253 0 0-.04.683.474.675 1.317-.018 1.317 2.492 1.317 2.492"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M38.541 18.776v-2.15c-1.276.135-2.978-1.757-2.978-1.757-2.306 2.374-7.9 1.702-7.9 1.702v2.205M19.507 33.1v.644c0 2.701 2.158 3.935 4.82 3.935 2.661 0 4.819-1.234 4.819-3.935V33.1M27.413 37.103a4.942 4.942 0 0 1 1.763 3.797M19.478 40.9c0-1.529.686-2.895 1.763-3.798"
      />
      <g fill="#FFF" fillRule="nonzero" transform="translate(22.258 32.337)">
        <ellipse cx="3.457" cy=".706" rx="1" ry="1" />
        <ellipse cx=".68" cy=".706" rx="1" ry="1" />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M24.991 34.734a.262.262 0 0 0-.26-.264h-.808a.262.262 0 0 0-.26.264l.664.476.664-.476z"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21.31 29.635v2.11c0 .793-.633 1.435-1.414 1.435-.78 0-1.414-.643-1.414-1.435v-1.23c0-.793.578-1.741 1.414-2.092 0 0 1.767-.882 4.563-.882 2.798 0 4.257.882 4.257.882.892.433 1.414 1.299 1.414 2.092v1.23c0 .793-.633 1.435-1.414 1.435a1.425 1.425 0 0 1-1.414-1.435v-2.11"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ReasonsBlock/Svgs.js